export default function (props: any) {
    return (
        <svg width="272px" height="16px" viewBox="0 0 272 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="M端" transform="translate(-23.000000, -1738.000000)" stroke="#FF7319" strokeWidth="2.99683295">
                    <g id="编组-14" transform="translate(0.000000, 1644.000000)">
                        <path
                            d="M25.0455265,100.873146 C110.026589,110.067989 199.329571,109.896045 292.954473,100.357313"
                            id="路径-4"
                            transform="translate(159.000000, 104.000000) scale(-1, 1) rotate(2.000000) translate(-159.000000, -104.000000) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
